<b-collapse class="card is-collapsible" :class="{'is-frameless': frameless}" animation="slide" v-model="isOpen" :aria-id="id">
	<template #trigger="props">
		<div class="card-header" role="button" :aria-controls="id" :aria-expanded="props.open">
			<div class="card-header__content">
				<slot name="header" />
			</div>
			<span class="card-header__icon">
				<b-icon size="is-medium" :icon="props.open ? 'arrow-up' : 'arrow-down'" />
			</span>
		</div>
	</template>
	<div class="card-content is-clearfix" :class="{'p-0': fullbleed}">
		<slot />
	</div>
</b-collapse>
